import { ReadabilityAndEmotionalityGrade } from 'features/flashScore/getEmotionalityTranslationLabel';

export const getReadabilityTranslationLabel = (grade: ReadabilityAndEmotionalityGrade) =>
  `flashScore.readability.score_${grade}`;
